import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Form, FormGroup, Label, Input } from 'reactstrap'
import { getIdData, addData, updateData } from '../../lib/awardlist'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { ClassForLessonSelect, RecognitionLevelSelect, RankingSelect } from '../Common/FormSelects'

const StudentAwardEdit = () => {
	const [gradelevel, setGradelevel] = useState()
	const [recoglevel, setRecoglevel] = useState()
	const [sortOrder, setSortOrder] = useState(0)
	const [description, setDescription] = useState('')
	const [ranking, setRanking] = useState('')
	const [loading, setLoading] = useState(false)

	const { user } = useAuth()
	const navigate = useNavigate()
	const { status, id } = useParams()

	const getData = async () => {
		try {
			setLoading(true)
			const organizationData = await getIdData(id)
			if (organizationData && organizationData.length > 0) {
				setDescription(organizationData[0].description || '')
				setGradelevel(organizationData[0].gradelevel || '')
				setRecoglevel(organizationData[0].recoglevel || '')
				setSortOrder(organizationData[0].sortorder || 0)
				setRanking(organizationData[0].ranking || '')
			}
		} catch (error) {
			console.error('Error fetching award:', error)
		} finally {
			setLoading(false)
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)

		try {
			const formData = {
				studentId: user?.id,
				gradelevel,
				recoglevel,
				description,
				sortorder: sortOrder,
				ranking
			}

			if (status === 'Add') {
				await addData(formData)
			} else {
				await updateData({ id, ...formData })
			}

			navigate(-1)
		} catch (error) {
			console.error('Error saving award:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (status === 'Update' && id) {
			getData()
		}
	}, [status, id])

	return (
		<StudentTopMenuLayout activeMenu="Activities/Awards" pageName="AwardEdit" showPageNotes={false}>
			<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
				<div className="card-header bg-white border-bottom">
					<h5 className="mb-0 text-dark">{status === 'Add' ? 'Add Award' : 'Update Award'}</h5>
				</div>
				<div className="card-body bg-white">
					{loading && status === 'Update' ? (
						<div className="text-center p-4">
							<div className="spinner-border" role="status">
								<span className="visually-hidden">Loading...</span>
							</div>
						</div>
					) : (
						<Form onSubmit={handleSubmit}>
							<div className="row">
								<div className="col-lg-9 col-md-12">
									<FormGroup className="mb-3">
										<Label className="form-control-label fw-bold mb-2">Order</Label>
										<Input
											type="number"
											value={sortOrder}
											onChange={(e) => setSortOrder(e.target.value)}
											className="form-control border-radius-10"
											required
											style={{
												border: '1px solid #e9ecef',
												boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
												height: '45px',
												padding: '10px 15px'
											}}
										/>
									</FormGroup>

									<FormGroup className="mb-3">
										<Label className="form-control-label fw-bold mb-2">Grade Level</Label>
										<ClassForLessonSelect value={gradelevel} name="Grade Level" setValue={setGradelevel} />
									</FormGroup>

									<FormGroup className="mb-3">
										<Label className="form-control-label fw-bold mb-2">Recognition Level</Label>
										<RecognitionLevelSelect value={recoglevel} setValue={setRecoglevel} />
									</FormGroup>

									<FormGroup className="mb-3">
										<Label className="form-control-label fw-bold mb-2">Ranking</Label>
										<RankingSelect value={ranking} setValue={setRanking} />
									</FormGroup>

									<FormGroup className="mb-3">
										<Label className="form-control-label fw-bold mb-2">Award</Label>
										<Input
											type="textarea"
											rows="4"
											value={description}
											onChange={(e) => setDescription(e.target.value)}
											className="form-control border-radius-10"
											placeholder="Award Description"
											style={{
												resize: 'vertical',
												minHeight: '100px',
												border: '1px solid #e9ecef',
												boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
											}}
										/>
									</FormGroup>

									<div className="d-flex justify-content-between mt-4">
										<button type="submit" className="btn btn-primary" disabled={loading}>
											<i className="fa fa-save me-2"></i>
											{loading ? 'Saving...' : status === 'Add' ? 'Add Award' : 'Update Award'}
										</button>
										<button type="button" onClick={() => navigate(-1)} className="btn btn-secondary">
											Cancel
										</button>
									</div>
								</div>
							</div>
						</Form>
					)}
				</div>
			</div>
		</StudentTopMenuLayout>
	)
}

export { StudentAwardEdit }
